import { BreachPathAppBaseDataProvider } from './BreachPathAppBaseDataProvider';
import { BreachPathAppWebComponentSchema } from '../types';

export class BreachPathAppGZDataProvider extends BreachPathAppBaseDataProvider {
  async getDataForView(): Promise<BreachPathAppWebComponentSchema> {
    return {} as unknown as BreachPathAppWebComponentSchema;
  }

  async getBreachPathIssueDataById(issueId: string): Promise<any> {
    return this.dependencies.api.clients.BreachPathIssues.getBreachPathIssueDataById({ issueId }).toPromise();
  }
}
